module.exports = __webpack_public_path__ + "static/media/hiw15.2847bf0d.svg";